<template>
  <div class="mb-4" v-if="taskInfo !== null && saSearchEnabled()">
    <!-- v-if="taskInfo !== null" -->
    <!--#region -- Content ---->

    <div class="stage-header border-bottom mb-4">

      <b-tabs pills card v-model="activeTab" @input="onTabChange">
        <b-tab title="Task" active>

          <div class="caption-label">Task Information</div>
          <div class="row mb-4">
            <div class="col-6">
              <div class="header-col">
                <div>Subject</div>
                <div>{{ _.get(taskInfo, 'subject', '') }}</div>
              </div>
              <div class="header-col">
                <div>Task ID</div>
                <div>
                  {{ _.get(taskInfo, 'task_id', '') }}
                  <!--
              <a v-if="taskInfo !== null
                 && (approveProposalPermission() || editSubjectPermisson() )
                 && _.get(ftie_page_obj, 'salesforce_es_id', null) != null"
                 class="link"
                 target="_blank"
                 :href="safeUrl(`${ frontEndUrlToUse }engineering-service/opty-id/${ _.get(ftie_page_obj, 'salesforce_es_id', null) }`)">
                (view ES details)
              </a>
              -->

                </div>
              </div>
              <div class="header-col">
                <div>Priority</div>
                <div>{{ _.get(taskInfo, 'priority', '') }}</div>
              </div>
              <div class="header-col">
                <div>Category</div>
                <div>{{ _.get(taskInfo, 'task_type', '') }}</div>
              </div>

              <div class="header-col">
                <div>Status</div>
                <div>
                  {{ _.get(taskInfo, 'task_status', '') }}

                </div>

                <div v-if="taskInfo.owner_name===login_user_name ||taskInfo.assign_name===login_user_name || login_user_name=='power' || (userRoles != null & userRoles.includes('Admin'))"
                     style="margin-left: 5px;">
                  <!--<b-form-checkbox v-model="ticketOpen"
                               name="check-button"
                               @change="closeTask"
                               switch>
                <p style="color:#F77530">Switch left to <b>close</b> ticket </p>
              </b-form-checkbox>-->
                  <b-button @click="showSaUpdateTask()" variant="primary" size="sm">update</b-button>
                </div>
                <!-- close task-->

                <b-modal centered ok-title="Update" @ok="closeTask"
                         cancel-title="Cancel"
                         ok-variant="primary"
                         ref="SaCloseTaskModal" :title="`Update Task`"
                         button-size="sm">

                  <div class="row">
                    <div class="col-auto">
                      <div class="label mt-2">Update Status:</div>
                    </div>
                    <div class="col-auto">
                      <b-form-select v-model="changeStatus" :options="task_status_options" label="Status:"></b-form-select>
                    </div>
                    <!--<div class="col-auto" style="width: 300px;">
                  <gtc-textarea v-model="closeMasterTicketReason" />
                </div>-->
                    <!--<div :class="[classObject(closeMasterTicketReason, 255)]" style="padding-left: 162px;">
                  <span>You've input: {{ closeMasterTicketReason | getInputLength }}/255</span>
                </div>-->
                  </div>
                </b-modal>

                <!-- End Region ---- TODO: CLOSE task -->

              </div>

              <div class="header-col">
                <div>Create By</div>
                <div>{{ _.get(taskInfo, 'create_by_name', '') }}</div>
              </div>

            </div>

            <div class="col-6">
              <div class="header-col">
                <div>Relate to Opportunity</div>
                <a v-if="taskInfo!= null
                   && _.get(taskInfo, 'opty_id', '') != null
                   && _.get(taskInfo, 'opty_id', '') != ''"
                   class="link"
                   target="_blank"
                   :href="safeUrl(`${ frontEndUrlToUse }opportunity/opty-id/${ _.get(taskInfo, 'opty_id', '') }`)">
                  {{ _.get(taskInfo, 'opty_name', '') }}
                </a>
                <!--
                            <gtc-opportunity v-if="taskInfo != null" :opportunityId="taskInfo.opty_id"
                                             :opportunityName="taskInfo.opty_name" />
            -->

              </div>
              <div class="header-col">
                <div>Relate to Customer</div>
                <div></div>
                <div v-if="taskInfo !== null && _.get(taskInfo, 'customer_account_id', '') !== ''">
                  <a class="link" target="_blank" :href="safeUrl(`${ frontEndUrlToUse }opportunity/account-id/${_.get(taskInfo, 'customer_account_id', '') }`)">{{ _.get(taskInfo, 'customer_account_name', '') }}</a>
                </div>
                <div v-else>
                  {{ _.get(taskInfo, 'customer_account_name', '')}}
                </div>
              </div>
              <div class="header-col">
                <div>Create Date</div>
                <div>{{ _.get(taskInfo, 'created_date', '') | dateTimeFormat}}</div>
              </div>
              <div class="header-col">
                <div>Due Date</div>
                <div>{{ _.get(taskInfo, 'due_date', '') | dateTimeFormat}}</div>
              </div>
              <div class="header-col">
                <div>Last Update Date</div>
                <div>{{ _.get(taskInfo, 'complete_date', '') | dateTimeFormat}}</div>
              </div>
              <div class="header-col">
                <div>Complete Date</div>
                <div>{{ _.get(taskInfo, 'complete_date', '') | dateTimeFormat}}</div>
              </div>
            </div>

          </div>
        </b-tab>
        <b-tab v-if="taskInfo !=null && taskInfo.opty_id != null && taskInfo.opty_id != ''" title="Opportunity Info" @click="getOptyInfo">
          <div class="caption-label">
            Relative Opportunity Info
          </div>

          <div class="row mb-4">
            <div class="col-12">
              <div class="header-col">
                <div>Opportunity Name</div>
                <!--
            <gtc-opportunity v-if=" sf_opty_info!= null" :opportunityId="sf_opty_info.ID"
              :opportunityName="sf_opty_info.NAME" /> -->
                <a v-if="sf_opty_info!= null
                   && _.get(sf_opty_info, 'ID', '') != null
                   && _.get(sf_opty_info, 'ID', '') != ''"
                   class="link"
                   target="_blank"
                   :href="safeUrl(`${ frontEndUrlToUse }opportunity/opty-id/${ _.get(sf_opty_info, 'ID', '') }`)">
                  {{ _.get(sf_opty_info, 'NAME', '') }}
                </a>

              </div>
            </div>
            <div class="col-12">
              <div class="header-col">
                <div>Opportunity Number</div>
                <div>{{ _.get(sf_opty_info, 'OPPORTUNITY_NUMBER__C', '') }} </div>
              </div>
            </div>
            <div class="col-12">
              <div class="header-col">
                <div>Account Name</div>
                <div><a class="link" target="_blank" :href="safeUrl(`${ frontEndUrlToUse }opportunity/account-id/${_.get(sf_opty_info, 'ACCOUNTID', '') }`)">{{ _.get(sf_opty_info, 'ACCOUNT_NAME', '') }}</a> </div>

              </div>
            </div>
            <!-- 1---------------------------------------------------------->
            <div class="col-4">
              <div class="header-col">
                <div>Opportunity Owner</div>
                <div>{{ _.get(sf_opty_info, 'OWNER_NAME', '') }} </div>
              </div>
              <div class="header-col">
                <div>Create By</div>
                <div>{{ _.get(sf_opty_info, 'CREATEDBY_NAME', '') }} </div>
              </div>
              <div class="header-col">
                <div>Key Opportunity</div>
                <div>{{ _.get(sf_opty_info, 'KEY_OPPORTUNITY__C', '') }}</div>
              </div>
              <div class="header-col">
                <div>Global Enterprise Opportunity</div>
                <div>{{ _.get(sf_opty_info, 'GLOBAL_ENTERPRISE_OPPORTUNITY__C', '') }}</div>
              </div>

              <div class="header-col">
                <div>Video Bussiness</div>
                <div>{{ _.get(sf_opty_info, 'VIDEO_BUSINESS__C', '') }}</div>
              </div>

              <div class="header-col">
                <div>Status</div>
                <div>{{ _.get(sf_opty_info, 'STATUS__C', '') }}</div>
              </div>

              <div class="header-col">
                <div>Stage</div>
                <div>{{ _.get(sf_opty_info, 'STAGENAME', '') }}</div>
              </div>
              <div class="header-col">
                <div>Probability (%)</div>
                <div>{{ _.get(sf_opty_info, 'PROBABILITY', '') }}</div>
              </div>
            </div>

            <!-- 2---------------------------------------------------------->
            <div class="col-4">
              <div class="header-col">
                <div>Type</div>
                <div>{{ _.get(sf_opty_info, 'TYPE', '') }} </div>
              </div>
              <div class="header-col">
                <div>
                  Classification
                </div>
                <div>{{ _.get(sf_opty_info, 'CLASSIFICATION__C', '') }}</div>
              </div>
              <div class="header-col">
                <div>
                  Close Date
                </div>
                <div>{{ _.get(sf_opty_info, 'CLOSEDATE', '') }} </div>
              </div>
              <div class="header-col">
                <div>Close Reason</div>
                <div>{{ _.get(sf_opty_info, 'CLOSE_REASON__C', '') }}</div>
              </div>
              <div class="header-col">
                <div>
                  Loss Reason
                </div>
                <div>{{ _.get(sf_opty_info, 'LOSS_REASON__C', '') }}</div>
              </div>

              <div class="header-col">
                <div>
                  Technical Stage
                </div>
                <div>{{ _.get(sf_opty_info, 'TECHNICAL_STAGE__C', '') }}</div>
              </div>

              <div class="header-col">
                <div>
                  Must Win
                </div>
                <div>{{ _.get(sf_opty_info, 'MUST_WIN__C', '') }}</div>
              </div>
              <div class="header-col">
                <div>
                  Must Win Type
                </div>
                <div>{{ _.get(sf_opty_info, 'MUST_WIN_TYPE__C', '') }}</div>
              </div>
            </div>

            <!-- 0---------------------------------------------------------->


            <div class="col-4">

              <div class="header-col">
                <div>Country</div>
                <div>{{ _.get(sf_opty_info, 'ACCOUNT_COUNTRY__C', '') }}</div>
              </div>

              <div class="header-col">
                <div>Opportunity Currency</div>
                <div>{{_.get(sf_opty_info, 'CURRENCYISOCODE', '') }}</div>
              </div>


              <div class="header-col">
                <div>Primary Sales Contact</div>
                <div>{{_.get(sf_opty_info, 'ACCOUNT_PRIMARY_SALES_CONTACT__C', '') }}</div>
              </div>

              <div class="header-col">
                <div>
                  Primary Tech Contact
                </div>
                <div>{{_.get(sf_opty_info, 'ACCOUNT_PRIMARY_TECHNICAL_CONTACT__C', '') }}</div>
              </div>
              <div class="header-col">
                <div>Lead Source</div>
                <div>{{ _.get(sf_opty_info, 'LEADSOURCE', '') }}</div>
              </div>
              <div class="header-col">
                <div>Industry</div>
                <div>{{ _.get(sf_opty_info, 'VERTICAL_INDUSTRY__C', '') }}</div>
              </div>
              <div class="header-col">
                <div>Vertical</div>
                <div>{{ _.get(sf_opty_info, 'SUB_VERTICAL_INDUSTRY__C', '') }}</div>
              </div>

            </div>

            <div class="col-12">
              <div class="header-col">
                <div>Customer Comments</div>
                <div>{{ _.get(sf_opty_info, 'CUSTOMER_COMMENTS__C', '') }}</div>
              </div>
            </div>
            <div class="col-12">
              <!-- PERSONAL_NOTES__C -->
              <div class="header-col">
                <div>Personal Notes</div>
                <button type="button"
                        class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                        v-b-tooltip.hover.topleft
                        title="Store any personal notes here, such as meeting minutes or for making a quick note outside of updating the 'Latest Update Information'."></button>
                <div v-if="sf_opty_info != null" v-html="sf_opty_info.PERSONAL_NOTES__C"></div>
              </div>
            </div>
            <div class="col-12">
              <div class="header-col">
                <div>Latest Update Info</div>
                <div v-if="sf_opty_info != null" v-html="sf_opty_info.LATESTINFORMATION__C"></div>
              </div>
            </div>
          </div>
          <!-- region: SKU PN Loader -->

          <div v-if="sfdc_prd_line_loading" class="caption-label-hide d-flex">
            <div>
              <i v-if="sfdc_prd_line_loading" style="color: #f77530;" class="fa fa-circle-o-notch fa-spin fa-fw"> </i>
              Salesforce Product
            </div>
          </div>

          <div v-else style="padding-left: 17px;">


            <sfdc-prd-line-view-only v-if="sfdcProducts!=null"
                                     :prop_sfdc_page_obj="sfdcProducts"
                                     :prop_user="login_user_name"
                                     :prop_user_sites="userSites" />
          </div>
          <!-- endregion -->
          <!-- region ES List-->
          <div v-if="sfdc_es_loading" class="caption-label-hide d-flex">
            <div>
              <i v-if="sfdc_es_loading" style="color: #f77530;" class="fa fa-circle-o-notch fa-spin fa-fw"> </i>
              Engineering Services
            </div>
          </div>

          <div v-else style="padding-left: 17px;">
            <sfdc-engineering-services v-if="sf_es_list!=null && saSearchEnabled()"
                                       :prop_sfdc_es="sf_es_list"
                                       :prop_opp_id="taskInfo.opty_id"
                                       :prop_user="login_user_name"
                                       :prop_user_sites="userSites" />
          </div>

          <!-- endregion -->
          <!-- region: Demo Loans Loader -->

          <div v-if="sfdc_demo_loans_loading" class="caption-label-hide d-flex">
            <div>
              <i v-if="sfdc_demo_loans_loading" style="color: #f77530;" class="fa fa-circle-o-notch fa-spin fa-fw"> </i>
              Salesforce Demo Loans
            </div>
          </div>

          <div v-else style="padding-left: 17px;">
            <sfdc-demo-loans v-if="sf_demo_loans!=null && saSearchEnabled()"
                             :prop_sfdc_demo_loans="sf_demo_loans"
                             :prop_user="login_user_name"
                             :prop_user_sites="userSites" />
          </div>

          <!-- endregion -->
        </b-tab>
      </b-tabs>


      <div style="padding-left: 17.5px">
        <div class="caption-label">Task Description</div>
        <div class="row mb-4">
          <div class="col-12">
            <div class="header-col">
              <div>Comments</div>
              <div v-if="taskInfo!=null" v-html="taskInfo.description"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- region: task attachment -->
      <div style="padding-left: 17.5px"
           v-if="sfdc_task_attachment_loading"
           class="caption-label-hide d-flex">
        <div>
          <i v-if="sfdc_task_attachment_loading" style="color: #f77530;" class="fa fa-circle-o-notch fa-spin fa-fw"> </i>
          Task Attachments
        </div>
      </div>

      <div v-else style="padding-left: 17px;">
        <sfdc-attachments v-if="sf_task_attachment_list!=null && saSearchEnabled()"
                          :prop_attachment_link_type="attachmentLinkObject"
                          :prop_sfdc_attachments="sf_task_attachment_list"
                          :prop_user="login_user_name"
                          :prop_user_sites="userSites" />
      </div>

      <!-- end region -->

    </div>


    <div style="padding-left: 17.5px">
      <div class="caption-label"> Actions</div>
      <div class="row mb-4">
        <div class="col-12">
          <!--<b-button v-if=" ( taskInfo!= null && taskInfo.opty_id != null && (taskInfo.owner_name===login_user_name ||taskInfo.assign_name===login_user_name) ) || login_user_name=='power' || (userRoles != null & userRoles.includes('Admin'))"
        style="width: 19rem" variant="primary">New an Engineering Service/FTIE</b-button>-->
          <a v-if=" ( taskInfo!= null && taskInfo.opty_id != null) || ( taskInfo!= null && taskInfo.customer_account_id != null) || login_user_name=='power' || (userRoles != null & userRoles.includes('Admin'))"
             class="btn btn-primary"
             target="_blank"
             :href="safeUrl(`${ $root.frontEndUrl }/engineering-service/new/${taskInfo.opty_id}`)">New an Engineering Service/FTIE</a>
        </div>
      </div>
    </div>


  </div>
</template>
<script>
  import * as moment from 'moment/moment';
  import { safeUrl } from '@/helpers/vue-url';
  import { safeHtml } from '@/helpers/vue-safehtml';
  export default {
    name: 'task-page',
    props: {
      prop_task_page_obj: {
        default: null
      },
      prop_user_sites: {
        default: null
      },
      prop_user: {
        default: null
      },
      prop_user_roles: {
        default: null
      },
    },
    data() {
      return {
        attachmentLinkObject: 'Task',
        activeTab: 0,
        visible: false,
        taskInfo: null,
        sf_opty_info: null,
        taskId: encodeURIComponent(this.$route.params.task_id),
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        userFunctions: null,
        userRoles: null,
        userSites: null,
        login_user_name: null,
        createBy: null,
        date_from: null,
        isShowingCollapse: {
          'accordion-1': true,
          'accordion-2': false,
          'accordion-3': false,
          'accordion-4': false
        },
        collapseFulfillStatus: {
          'accordion-1': false,
          'accordion-2': false,
          'accordion-3': false,
          'accordion-4': false
        },

        text: `(Please note that the customization request only open to the ticket which has opportunity.)
        `,
        breadcrumbItems: [
          {
            text: 'Engineering Service (SFDC)',
            active: true,
          },
        ],
        searching: false,
        searchingNre: false,
        searchingStdSku: false,
        sfdc_demo_loans_loading: true,
        sfdc_es_loading: true,
        sfdc_task_attachment_loading: true,
        basicInfo: null,
        sfdcProducts: null,
        sf_demo_loans: null,
        sf_es_list: null,
        sf_task_attachment_list: null,
        missingData: 'N/A (Old data not found)',
        readOnly: false,
        selectRsm: null,
        configuration: '',
        task_status_options: ['Not Started', 'In Progress', 'Completed'],
        changeStatus: '',
        sfdc_prd_line_loading: true,
        isCollapsed: false,
        skuPnDisplayed: true,
        null_request_detail_id: null,
        access_to_opty: false,
      };
    },
    created() {
      let self = this;
      self.date_from = moment().format('YYYY-MMM-DD');
      self.userSites = self.prop_user_sites;
      self.login_user_name = self.prop_user;
      self.userRoles = self.prop_user_roles;
      self.checkLoggedIn();
      self.access_to_opty = self.saSearchEnabled();
      if (self.prop_task_page_obj == null) {
        self.getPage();
      } else {
        self.taskInfo = self.prop_task_page_obj;
        self.taskId = self.taskInfo.task_id;
        self.getTaskAttachment();
        }
     },
    methods: {
      prdEnv() {
        return 'PRD' === this.$session.get('mode');
      },
      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }
        var user_name = this.$session.get('user_name');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');

        this.login_user_name = user_name
        this.userFunctions = user_functions;
        this.userRoles = user_roles;
        this.userSites = user_site;
      },
      saSearchEnabled() {
        let self = this;
        if ((self.userRoles && (_.indexOf(self.userRoles, 'Admin') > -1 || (_.indexOf(self.userRoles, 'ES_PM_Leader') > -1 && self.userSites && _.indexOf(self.userSites, 'Getac') > -1))  || (self.userFunctions && _.indexOf(self.userFunctions, 'Customer Success Manager') > -1))
        ) {
          console.log("Search Enabled!!");
          return true
        }
        if (((self.userSites && _.indexOf(self.userSites, 'GUSA') > -1 && self.userRoles && _.indexOf(self.userRoles, 'GRO_SA') > -1) && self.userRoles && (_.indexOf(self.userRoles, 'GRO_SA_Leader') > -1 || _.indexOf(self.userRoles, 'GRO_SA') > -1))) {
          console.log("Search Enabled!!");
          return true
        }
        console.log("Search Disabled!!");
        return false;
      },

      classObject(input, maxLength) {
        return {
          'text-danger': this.$options.filters['reachLength'](input, maxLength),
          'text-success': !this.$options.filters['reachLength'](input, maxLength),
          'text-weight': this.$options.filters['reachLength'](input, maxLength) ? 'bold' : 'normal'//,
        }
      },

      isShowingCollapseFunc(accordionId) {
        let self = this;
        return _.get(self.isShowingCollapse, accordionId, false);
      },

      // Toggle Both Collapse A and B (by IDS list)
      toggleCollapses(ids) {
        ids.forEach((id) => {
          this.$root.$emit('bv::toggle::collapse', id)
        })
      },


      getPage(callback) {
        let self = this;
        let requestData = {
          //create_by: self.createBy,
          username: self.loginUser,
          task_id: self.taskId,
          // opty_id: self.sfdcOptyEsId,
          site: self.$session.get('user_site'),
          // es_under_opty_id: '',
        };
        //self.searching = true;
        eventHub.$emit('loading', true);
        let urlById = self.$root.baseUrl + '/task/back-end/task-id/';
        this.$axios
          .post(self.$root.baseUrl + '/task/back-end/task-id/' + self.taskId, requestData)
          .then(res => {
            let result = res.data;
            result.task_info = JSON.parse(result.task_info);
            self.taskInfo = result.task_info;
            self.taskId = self.taskInfo.task_id;
          })
          .finally(() => {
            console.log("COMPLETE .../task-id/");
            if (self.taskInfo !== null) {
              self.taskInfo = JSON.parse(JSON.stringify(self.taskInfo));
              self.getTaskAttachment();
            }
            eventHub.$emit('loading', false);
          });
      },
      closeTask() {
        let self = this;
        let requestData = {
          status: self.changeStatus,
          task_id: self.taskInfo.task_id,
       /*   description: self.taskInfo.description,*/
        };
        eventHub.$emit('loading', true);
        let actionResult = false;
        this.$axios
          .post(self.$root.baseUrl + '/task/back-end/task-update/', requestData)
          .then(res => {
            let result = res.data;
            actionResult = result.isSuccess;
          })
          .finally(() => {
            if (actionResult) {
              self.getPage();
            }
            eventHub.$emit('loading', false);
          });
      },
      showSaUpdateTask() {
        let self = this;
        self.changeStatus = self.taskInfo.task_status;
        self.$refs['SaCloseTaskModal'].show()
      },
      getTaskAttachment() {
        let self = this;
        // salesforce-py/attachment/parent-id/<str:attachment_parent_id>
        let requestData = {
          parent_tye: self.attachmentLinkObject,
          parent_id: self.taskInfo.task_id, //_.get(self.sf_opty_info, 'ACCOUNTID', ''),
          site: self.userSites,
          user_name: self.login_user_name,
          user_functions: self.userFunctions,
          user_roles: self.userRoles,
        };
        self.sfdc_task_attachment_loading = true;
        this.$axios.post(self.$root.baseUrl + '/salesforce-py/attachment/parent-id/' + self.taskInfo.task_id, requestData)
          .then(res => {
            let result = res.data;
            if (_.get(result, 'attachment_info_list', null) !== null) {
              self.sf_task_attachment_list = JSON.parse(result.attachment_info_list);
            }
          })
          .finally(() => {
            if (self.taskInfo.task_id !== null) {
              console.log("self.sf_task_attachment_list");
              console.log(self.sf_task_attachment_list);
            }
            // eventHub.$emit('loading', false);
            self.sfdc_task_attachment_loading = false;
          });
      },
      getEngineeringServices() {
        let self = this;
        let requestData = {
          account_id: self.taskInfo.opty_id, //_.get(self.sf_opty_info, 'ACCOUNTID', ''),
          opty_id: self.taskInfo.opty_id
        };
        if (self.sfdc_es_loading) {
          eventHub.$emit('loading', true);
        }
        self.sfdc_es_loading = true;
        this.$axios.post(self.$root.baseUrl + '/opportunity/back-end/engineering-services/parent-id/' + self.taskInfo.opty_id, requestData)
          .then(res => {
            let result = res.data;
            if (_.get(result, 'es_info_list', null) !== null) {
              self.sf_es_list = JSON.parse(result.es_info_list);
            }
          })
          .finally(() => {
            if (self.taskInfo.opty_id !== null) {
              console.log("self.sf_es_list");
              console.log(self.sf_es_list);
            }
            eventHub.$emit('loading', false);
            self.sfdc_es_loading = false;
          });
      },
      getDemoLoans() {
        let self = this;
        let requestData = {
          account_id: _.get(self.sf_opty_info, 'ACCOUNTID', ''),
          opty_id: self.taskInfo.opty_id,
        };
        if (self.sfdc_demo_loans_loading) {
          eventHub.$emit('loading', true);
        }
        self.sfdc_demo_loans_loading = true;
        this.$axios.post(self.$root.baseUrl + '/opportunity/back-end/demo-loans/opty-id/' + _.get(self.sf_opty_info, 'ACCOUNTID', ''), requestData)
          .then(res => {
            let result = res.data;
            if (_.get(result, 'demo_loan_list', null) !== null) {
              self.sf_demo_loans = JSON.parse(result.demo_loan_list);
            }
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            self.sfdc_demo_loans_loading = false;
          });
      },
      getOptyInfo() {
        // /opportunity/back-end/opty-id/<str:opty_id>
        let self = this;

        let requestData = {
          es_id: null,
          opty_id: self.taskInfo.opty_id,
          request_from: null
        };
        self.searching = true;
        eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/opportunity/back-end/opty-id/' + self.taskInfo.opty_id, requestData)
          .then(res => {
            let result = res.data;

            if (_.get(result, 'opty_info', null) !== null) {
              self.sf_opty_info = JSON.parse(result.opty_info);
            }
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            if (self.taskInfo !== null && self.taskInfo.opty_id !== null) {
              //console.log("self.sf_opty_info");
              //console.log(self.sf_opty_info);
              self.getSfProductline();
              self.getDemoLoans();
              self.getEngineeringServices();
            }

          });
      },

      getSfEsOptyInfo() {
        let self = this;

        let requestData = {
          es_id: null,
          opty_id: self.taskInfo.opty_id,
          request_from: null
        };
        self.searching = true;
        eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/ftie/get-sf-info/', requestData)
          .then(res => {
            let result = res.data;

            if (_.get(result, 'sf_opty_info', null) !== null) {
              self.sf_opty_info = JSON.parse(result.sf_opty_info);
            }
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            if (self.taskInfo !== null && self.taskInfo.opty_id !== null) {
              self.getSfProductline();
            }

          });

      },
      onTabChange(newIndex) {
        console.log("newIndex:" + newIndex);
        let self = this;

      },
      onShown() {
        this.isCollapsed = false;
      },
      onHidden() {
        this.isCollapsed = true;
      },
      getSfProductline() {
        let self = this;
        let requestData = {
          opty_id: self.taskInfo.opty_id,
          username: self.login_user_name,
        };
        self.searching = true;
        if (!self.sfdc_prd_line_loading) {
          eventHub.$emit('loading', true);
        }
        self.sfdc_prd_line_loading = true;
        this.$axios
          .post(self.$root.baseUrl + '/opportunity/back-end/product-line/opty-id/' + self.taskInfo.opty_id, requestData)
          .then(res => {
            let result = res.data;
            if (_.get(result, 'sfdc_prd_line_info_list', null) !== null &&
              _.size(_.get(result, 'sfdc_prd_line_info_list', new Array())) > 0) {
              result.sfdc_prd_line_info_list = JSON.parse(result.sfdc_prd_line_info_list);
            }
            self.sfdcProducts = result.sfdc_prd_line_info_list

          })
          .finally(() => {
            // console.log("COMPLETE .../opty-id/" + self.taskInfo.opty_id);
            eventHub.$emit('loading', false);
            self.sfdc_prd_line_loading = false;
          });

      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/task-management/TaskPage.vue